/* eslint-disable no-unused-vars */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-restricted-syntax */
/* eslint-disable camelcase */
import React, { useRef, useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spin } from 'antd';
import _ from 'lodash';
import { Autocomplete } from '@react-google-maps/api';
import { geocodeByAddress } from 'react-places-autocomplete';
import Button from '../../../../components/Button/Button';
import { setBusinessLocation, fetchNatCatProfiles } from '../../NatCatProfileActions';
import { sanitizeHTML } from '../../../../utils/sanitize';
import './AddressSearch.scss';

const AddressSearch = ({ showSearchBtn = false, onSearch, onAfterChange, showText = true }) => {
  const autocompleteRef = useRef();

  const [searchable, setSearchable] = useState(false);
  const [googleMapsLoaded, setGoogleMapsLoaded] = useState(false);
  const dispatch = useDispatch();
  const loadingNatCatProfiles = useSelector((state) => state.natcat.loadingNatCatProfiles);
  const location = useSelector((state) => state.natcat?.businessLocation);
  const profiles = useSelector((state) => state.natcat?.natcatProfiles);

  // Check if Google Maps is loaded
  useEffect(() => {
    const checkGoogleMaps = () => {
      if (window.google && window.google.maps && window.google.maps.places) {
        setGoogleMapsLoaded(true);
      } else {
        // Check again after a short delay
        setTimeout(checkGoogleMaps, 100);
      }
    };
    checkGoogleMaps();
  }, []);

  const onLoad = (autocomplete) => {
    autocompleteRef.current = autocomplete;
  };

  const getAddressComponent = (addressComponents, field) => {
    const result = _.find(addressComponents, (item) => _.includes(item.types, field));
    return result ? result.short_name : '';
  };

  const bindPostCode = async () => {
    const pacContainers = document.getElementsByClassName('pac-container');
    let pacItems;

    if (pacContainers && pacContainers.length > 1) {
      pacItems = pacContainers[pacContainers.length - 1].childNodes;
    } else {
      pacItems = document.getElementsByClassName('pac-item');
    }

    if (pacItems && pacItems.length > 0) {
      for (let i = 0; i < pacItems.length; i++) {
        const suggestedAddress =
          autocompleteRef.current?.gm_accessors_?.place?.Gt?.predictions?.[i]?.KF || pacItems[i].innerText;
        try {
          const addressComponents = await geocodeByAddress(suggestedAddress).then(
            (results) => results[0].address_components
          );
          const postcode = getAddressComponent(addressComponents, 'postal_code');
          if (pacItems[i] && postcode) {
            // Get the current text content safely
            const currentText = pacItems[i].textContent || pacItems[i].innerText || '';
            // Remove any existing postal-code spans
            const cleanedHTML = pacItems[i].innerHTML?.replace(/<span class=['"]postal-code['"]>.*?<\/span>/, '') || '';
            // Sanitize and create safe HTML with postcode
            const sanitizedPostcode = sanitizeHTML(postcode);
            const fullAddress = `${cleanedHTML} <span class='postal-code'>${sanitizedPostcode}</span>`;
            // Sanitize the entire HTML before setting
            const sanitizedHTML = sanitizeHTML(fullAddress);
            setTimeout(() => {
              if (pacItems[i]) {
                pacItems[i].innerHTML = sanitizedHTML;
              }
            }, 10);
          }
        } catch (error) {
          console.log('Error fetching address components:', error);
        }
      }
    }
  };

  const handleAddressInputChange = useCallback(_.debounce(bindPostCode, 600), []);

  const fetchNatCat = () => dispatch(fetchNatCatProfiles());
  const handleOnPlacesChanged = async () => {
    const address = autocompleteRef.current.getPlace();
    if (!address) return;
    let postcode = '';
    address.address_components.forEach((component) => {
      if (component.types.includes('postal_code')) {
        postcode = component.long_name;
      }
    });
    const { geometry, formatted_address } = address;
    const location = {
      address: formatted_address,
      lat: geometry.location.lat(),
      lng: geometry.location.lng(),
      postcode,
    };
    dispatch(setBusinessLocation(location));
    setSearchable(true);
    await dispatch(fetchNatCatProfiles());
    if (onAfterChange) {
      onAfterChange();
    }
  };

  return (
    <Spin spinning={loadingNatCatProfiles} tip="Loading natcat profiles..">
      {showText && (
        <>
          <h3 className="drawer-content-title">Location (NatCat)</h3>
          {location && (
            <>
              <h4>Currently selected location : </h4>
              <p className="selected-location">{location.address}</p>
            </>
          )}
          <p>
            Enter your location to visualise your natural hazard exposure. iProfileRisk NatCat data is sourced from
            SwissRe, providing 16 NatCat summaries for a specified location. To maintain integrity, we merely pass on
            this information without change.
          </p>
        </>
      )}

      <div className="report-address-search">
        {googleMapsLoaded ? (
          <Autocomplete onLoad={onLoad} onPlaceChanged={handleOnPlacesChanged} className="autocomplete">
            <input
              disabled={loadingNatCatProfiles}
              className="address-search"
              type="text"
              placeholder={location?.address && profiles ? 'Change Location' : 'Start typing the address'}
              onChange={handleAddressInputChange}
            />
          </Autocomplete>
        ) : (
          <input disabled className="address-search" type="text" placeholder="Loading Google Maps..." />
        )}
        {showSearchBtn && (
          <Button
            type="primary"
            className="address-search-button"
            onClick={onSearch || fetchNatCat}
            disabled={!searchable}
            loading={loadingNatCatProfiles}
          >
            {location?.address && profiles ? 'Change Location' : 'Search'}
          </Button>
        )}
      </div>
    </Spin>
  );
};

export default AddressSearch;
